(function () {
	'use strict';

	angular.module('mx.components').directive('mxConfigReader', function mxConfigReaderDirective() {
		return {
			restrict: 'E',
			controller: MxConfigReaderCtrl,
			controllerAs: 'vm',
			scope: {},
			bindToController: {
				path: '@',
				value: '=',
			},
		};
	});

	MxConfigReaderCtrl.$inject = ['mx.shell.Config'];

	function MxConfigReaderCtrl(mxConfig) {
		var vm = this;

		vm.$onInit = function () {
			vm.value = mxConfig.get(vm.path);
		};
	}
})();
